<template>
  <div>
    <el-form :model="fromData" label-width="200px" :rules="rules">
      <span style="font-size: 16px;font-weight: bold">物件信息：</span>
      <div style="border: #e7e7e7 1px solid">
        <el-row style="margin-top: 20px">
          <el-form-item label="物件番号：">
            <el-input class="inputStyle" v-model="fromData.wujian_id" disabled></el-input>
          </el-form-item>
          <el-form-item label="楼层：">
            <el-input class="inputStyle" v-model="fromData.floor" disabled></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="先行楼层：">
            <el-input class="inputStyle" v-model="fromData.advance_floor"></el-input>
          </el-form-item>
          <el-form-item label="重量(KG)：">
            <el-input class="inputStyle" v-model="fromData.weight"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="单元数(个)：">
            <el-input class="inputStyle" v-model="fromData.unit_num"></el-input>
          </el-form-item>
          <el-form-item label="面积(㎡)：">
            <el-input class="inputStyle" v-model="fromData.area"></el-input>
          </el-form-item>
        </el-row>
      </div>
      <span style="font-size: 16px;font-weight: bold">生产进度：</span>
      <div style="border: #e7e7e7 1px solid">
        <el-row style="margin-top: 20px">
          <el-form-item label="加工进度：">
            <el-input class="inputStyle" disabled>
              <template #prepend>
                <span>{{fromData.jg_schedule+'%'}}</span>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label="涂装进度：">
            <el-input class="inputStyle" disabled>
              <template #prepend>
                <span>{{fromData.tz_schedule+'%'}}</span>
              </template>
            </el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="组立进度：">
            <el-input class="inputStyle" disabled>
              <template #prepend>
                <span>{{fromData.zl_schedule+'%'}}</span>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label="出荷进度：">
            <el-input class="inputStyle" disabled>
              <template #prepend>
                <span>{{fromData.outbound_schedule+'%'}}</span>
              </template>
            </el-input>
          </el-form-item>
        </el-row>
      </div>
      <div v-if="fromData.is_balance">
        <span style="font-size: 16px;font-weight: bold">组立结余情况：</span>
        <div style="border: #e7e7e7 1px solid">
          <el-row style="margin-top: 20px">
            <el-form-item label="结余重量(kg)：" label-width="170px">
              <el-input class="inputWidthStyle" v-model="fromData.zl_balance_weight"></el-input>
            </el-form-item>
            <el-form-item label="结余单元个数(个)：" label-width="170px">
              <el-input class="inputWidthStyle" v-model="fromData.zl_balance_unit_num"></el-input>
            </el-form-item>
            <el-form-item label="结余面积(㎡)：" label-width="170px">
              <el-input class="inputWidthStyle" v-model="fromData.zl_balance_area"></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="结余批号：" label-width="170px">
              <el-input style="width: 700px" v-model="fromData.balance_batch_no"></el-input>
            </el-form-item>
          </el-row>
        </div>
      </div>

      <span style="font-size: 16px;font-weight: bold">先行计划：</span>
      <div style="border: #e7e7e7 1px solid">
        <el-form-item label="展开结束：" style="margin-top: 20px">
          <el-date-picker v-model="fromData.expand_end_date" style="width: 200px" type="date"
                          format="YYYY-MM-DD" value-format="YYYY-MM-DD"/>
        </el-form-item>
        <el-row>
          <el-form-item label="加工计划开始：">
            <el-date-picker v-model="fromData.jiagong_plan_start_date" style="width: 200px" type="date"
                            format="YYYY-MM-DD" value-format="YYYY-MM-DD"/>
          </el-form-item>
          <el-form-item label="加工计划结束：">
            <el-date-picker v-model="fromData.jiagong_plan_end_date" style="width: 200px" type="date"
                            format="YYYY-MM-DD" value-format="YYYY-MM-DD"/>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="涂装计划开始：">
            <el-date-picker class="dateItemStyle" v-model="fromData.tuzhuang_plan_start_date"
                            style="width: 200px" type="date" format="YYYY-MM-DD" value-format="YYYY-MM-DD"/>
          </el-form-item>
          <el-form-item label="涂装计划结束：">
            <el-date-picker v-model="fromData.tuzhuang_plan_end_date" style="width: 200px" type="date"
                            format="YYYY-MM-DD" value-format="YYYY-MM-DD"/>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="组立计划开始">
            <el-date-picker v-model="fromData.zuli_plan_start_date" style="width: 200px" type="date"
                            format="YYYY-MM-DD" value-format="YYYY-MM-DD"/>
          </el-form-item>
          <el-form-item label="组立计划结束：">
            <el-date-picker v-model="fromData.zuli_plan_end_date" type="date" style="width: 200px"
                            format="YYYY-MM-DD" value-format="YYYY-MM-DD"/>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="出荷：">
            <el-date-picker v-model="fromData.outbound_date" style="width: 200px" type="date"
                            format="YYYY-MM-DD" value-format="YYYY-MM-DD"/>
          </el-form-item>
          <el-form-item label="搬入：">
            <el-date-picker v-model="fromData.move_in_date" style="width: 200px" type="date"
                            format="YYYY-MM-DD" value-format="YYYY-MM-DD"/>
          </el-form-item>
        </el-row>
      </div>
      <el-form-item></el-form-item>
      <el-row>
        <el-col :span="24" style="text-align: center">
          <el-button type="primary" @click="updateData" :loading="loading">保存</el-button>
        </el-col>
      </el-row>
    </el-form>

  </div>
</template>

<script>
export default {
  name: "MfgWujianPlanEdit",
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    setting: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      loading: false,
      fromData: {
        balance_date: '',
      },
      zuLiPlanDateList: [],
      rules: {
        star: [{required: true, message: '', trigger: 'blur'}],
      },
    }
  },
  computed: {
  },
  methods: {
    //修改数据
    updateData() {
      this.loading = true
      this.$axios.post('mfg/wujianPlan/updateData', this.fromData).then(response => {

        let res = response.data
        if (res.code !== 0) {
          this.loading = false
          return this.$message.error(res.message);
        }
        this.loading = false
        this.setting.$fn.closeWindow();
        this.setting.$fn.reSearch();
        return this.$message.success('编辑成功!');
      })
    },
  }, created() {
    this.fromData = this.parentData
  }
}
</script>

<style scoped>
.inputStyle {
  width: 200px;
}

.inputWidthStyle {
  width: 120px;
}

.dateItemStyle {
  width: 150px;
}

.left-aligned-slot {
  display: inline-block;
  text-align: left;
}

.height {
  line-height: 40px;
  height: 40px;
}
</style>